module.exports = "/images/cold@3x.png?10875a43db42b993f81bf370be14a66c";